// extracted by mini-css-extract-plugin
var _1 = "CourseProgressElement_root__2272a";
export { _1 as "root" }
